import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Home, LogOut, HelpCircle } from "lucide-react";
import { clearSession, getRole } from "@/lib/api";

export default function Header({ title = "Till Trax", onBack }) {
  const nav = useNavigate();
  const loc = useLocation();
  const role = getRole();
  const showHome = loc.pathname !== "/";
  const showHelp = loc.pathname !== "/help";
  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-30 backdrop-blur-md bg-[#FDFBF7]/85 border-b border-[#E8E4DA]"
    >
      <div className="max-w-md mx-auto flex items-center justify-between px-5 py-3.5">
        <div className="flex items-center gap-3 min-w-0">
          {onBack && (
            <button
              data-testid="hdr-back"
              onClick={onBack}
              className="text-[#2B533E] text-sm hover:underline"
            >
              ← Back
            </button>
          )}
          <div className="min-w-0">
            <div className="font-serif text-[#0D311E] text-lg leading-none truncate" style={{ fontFamily: "'Fraunces', serif" }}>
              {title}
            </div>
            <div className="text-[10px] tracking-[0.18em] text-[#5C7566] uppercase mt-1">
              Aguasabon Golf Club
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <span
            data-testid="draft-badge"
            className="inline-flex items-center rounded-full bg-[#D19C4C]/20 px-2.5 py-1 text-[10px] font-semibold text-[#A76A1F] uppercase tracking-[0.18em]"
          >
            Draft
          </span>
          {showHome && (
            <button
              data-testid="hdr-home"
              aria-label="Home"
              onClick={() => nav("/")}
              className="text-[#2B533E] hover:text-[#0D311E] p-1.5 rounded-md hover:bg-[#F5F2EA]"
            >
              <Home size={18} />
            </button>
          )}
          {showHelp && (
            <button
              data-testid="hdr-help"
              aria-label="Help"
              onClick={() => nav("/help")}
              className="text-[#2B533E] hover:text-[#0D311E] p-1.5 rounded-md hover:bg-[#F5F2EA]"
            >
              <HelpCircle size={18} />
            </button>
          )}
          {role && (
            <button
              data-testid="hdr-logout"
              aria-label="Sign out"
              onClick={() => {
                clearSession();
                nav("/login", { replace: true });
              }}
              className="text-[#5C7566] hover:text-[#0D311E] p-1.5 rounded-md hover:bg-[#F5F2EA]"
            >
              <LogOut size={16} />
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
